<template>
  <generic-modal :title="$t('service')" ref="generic_modal">
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="general"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="info icon" aria-hidden="true"></i>
            <span>{{ $t("general") }}</span>
          </a>
        </li>
        <li data-tab="inspection" @click="change_active_tab($event, this)">
          <a>
            <i class="eye icon" aria-hidden="true"></i>
            <span>{{ $t("inspection") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="is-fluid" ref="contents">
      <div class="" data-tab="general">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("reception date") }}</label>
              <div class="control">
                <input
                  type="datetime-local"
                  class="input"
                  v-model="meta.reception_date"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <!-- <div class="field">
              <input
                class="is-checkradio"
                type="checkbox"
                id="chk_is_recurrent"
                name="chk_is_recurrent"
                v-model="meta.is_recurrent"
              />
              <label for="chk_is_recurrent">{{ $t("is recurrent") }}</label>
            </div> -->
            <div class="field">
              <label class="label">{{ $t("customer name") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.customer" />
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("email") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.email" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("phone number") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.phone_number" />
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("brand") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.brand" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("line") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.line" />
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("mileage") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.mileage" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("year") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.year" />
              </div>
            </div>
          </div>
        </div>
        <div class="field">
          <generic-dropdown
            :title="$t('service type')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/mechanix/service-type/catalog"
            name_field="name"
            value_field="type_id"
            @selected="service_type_changed"
            ref="service_type_dropdown"
          />
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("service reason") }}</label>
              <div class="control">
                <textarea
                  class="textarea"
                  rows="2"
                  v-model="meta.service_reason"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="is-hidden" data-tab="inspection">
        <div class="field">
          <label class="label">{{ $t("diagnostic") }}</label>
          <div class="control">
            <textarea
              class="textarea"
              rows="2"
              v-model="meta.diagnostic"
            ></textarea>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <generic-uploader
              ref="revision_uploader"
              :idle_label="$t('drop photos here')"
              endpoint_url="/eserman/event/photo"
              @error="error_uploading"
              @success="success_uploading_revision"
              :allow_multiple="true"
            />
          </div>
        </div>

        <div class="grid is-col-min-7" v-if="meta.settings">
          <div
            class="cell"
            v-for="(photo, pidx) in meta.settings.revision_photos"
            :key="pidx"
          >
            <div class="card">
              <div class="card-image">
                <figure class="image is-128x128 m-auto py-3">
                  <v-lazy-image
                    :src="`${api_host}/drive/static/${photo.final_name}`"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <!-- <p class="subtitle is-7 has-text-centered">
                  {{ photo.file }}
                </p> -->
                    <p class="subtitle is-7 has-text-centered">
                      {{ photo.description }}
                    </p>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <div
                  class="button is-secondary card-footer-item"
                  @click="remove_revision_photo(pidx)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                  <!-- <span>{{ $t("delete") }}</span> -->
                </div>
                <div
                  class="button is-secondary card-footer-item"
                  @click="describe_revision_photo(photo)"
                  :data-tooltip="$t('describe')"
                >
                  <span class="icon">
                    <i class="fa fa-edit"></i>
                  </span>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span></button
      ><button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta && meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  get,
  post,
  error_alert,
  api_host,
  input_alert,
  generate_error_message_text,
  get_currency_settings,
  confirm_deletion_dialog,
  format_date,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import moment from "moment";
import { v4 } from "uuid";
import VLazyImage from "v-lazy-image";

export default {
  name: "ServiceModal",
  components: {
    GenericModal,
    GenericCalendar,
    GenericUploader,
    VLazyImage,
    GenericDropdown,
  },
  data() {
    let v = this;
    return {
      api_host,
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.reception_date || !v.meta.customer || !v.meta.brand;
    },
  },
  methods: {
    change_active_tab,
    moment,
    format_date,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(opts) {
      let v = this;
      v.set_initial_state();
      if (opts && opts.date && typeof opts.date === "object")
        v.meta.reception_date = moment(opts.date).format("YYYY-MM-DDTHH:mm");

      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      if (!v.meta.uuid) {
        put("/mechanix/service", data)
          .then((r) => {
            v.$emit("updated", r);
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        post("/mechanix/service", data)
          .then((r) => {
            v.$emit("updated", r);
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      v.$refs.revision_uploader.clear();
      v.$refs.service_type_dropdown.clear();
      v.meta.reception_date = moment().format("YYYY-MM-DDTHH:mm");
      // v.$refs.generic_uploader.clear();
    },
    edit_modal(event_uuid) {
      let v = this;

      get("/mechanix/service", { uuid: event_uuid })
        .then((event) => {
          v.meta = event;
          if (event.reception_date)
            v.meta.reception_date = moment(event.reception_date).format(
              "YYYY-MM-DDTHH:mm"
            );
          if (event.type_id)
            v.$refs.service_type_dropdown.set_value(event.type_id);
        })
        .catch((error) => {
          console.error("error", error);
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete service?"),
        v,
        () => {
          del("/mechanix/service", { uuid: v.meta.uuid })
            .then(() => {
              v.$emit("updated");
              v.close_modal();
            })
            .catch((error) => {
              v.error = generate_error_message_text(error);
            });
        }
      );
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      // let data = {
      //   file_id: rspnse.file.file_id,
      //   final_name: rspnse.final_name,
      // };

      if (v.meta.settings.photos) v.meta.settings.photos.push(rspnse);
      else v.meta.settings.photos = [rspnse];
    },
    success_uploading_revision(response) {
      let v = this;
      let rspnse = JSON.parse(response.serverId);
      if (v.meta.settings.revision_photos)
        v.meta.settings.revision_photos.push(rspnse);
      else v.meta.settings.revision_photos = [rspnse];
    },
    remove_revision_photo(index) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete photo?"), v, () => {
        v.meta.settings.revision_photos.splice(index, 1);
      });
    },
    describe_revision_photo(photo) {
      let v = this;
      let options = {
        input: "textarea",
        title: v.$t("describe photo"),
        input_value: photo.description,
        placeholder: v.$t("description"),
        confirm_text: v.$t("save"),
        cancel_text: v.$t("cancel"),
      };
      input_alert(options).then((value) => {
        photo.description = value;
      });
    },
    service_type_changed(value) {
      let v = this;
      if (value) v.meta.type_id = value.type_id;
    },
  },
  created() {},
  watch: {},
};
</script>
<style></style>
